import classNames from 'classnames'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { USER_SCREENS } from '../../../store/ui/ui.constants'
import { selectIsUserScreenDefault } from '../../../store/ui/ui.selectors'
import { setUiUserScreen } from '../../../store/ui/uiSlice'
import arrowLeft from '../../genericComponents/assets/arrow-left.svg'
import SVGIcon from '../../svg/SVGIcon'
import useEventCallback from '../../utils/useEventCallback'
import s from './UserScreenHeader.less'

const UserScreenHeader = ({ children, rightChildren, noBar = false }) => {
  const dispatch = useDispatch()
  const isDefaultScreen = useSelector(selectIsUserScreenDefault)

  const onBack = useEventCallback(() => dispatch(setUiUserScreen({ name: USER_SCREENS.default })))

  return (
    <div className={classNames(s.root, noBar && s.noBar)}>
      <div className={s.left}>
        {!isDefaultScreen && (
          <div className={s.back} onClick={onBack}>
            <SVGIcon url={arrowLeft} />
          </div>
        )}
      </div>
      <div className={`${s.title}`}>{children}</div>
      <div className={s.right}>{rightChildren}</div>
    </div>
  )
}

export default UserScreenHeader
